/* eslint-disable global-require */
export const MOCK_INFO = {
  videoId: 9000000005439200,
  cardList: Array.of
    .apply(null, new Array(5))
    .map(
      () => 'https://static.web.sdo.com/jijiamobile/pic/ff14/wallpaper/20200721patch52/ffxiv_5.2patch_01_2048x1536.jpg',
    ),
  notice: '2020年8月2日漫展信息展示漫展信息展示漫展信息展示漫展信息展示',
  cityList: [
    { id: 0, name: '北京', state: 0 },
    { id: 1, name: '青岛', state: 1 },
    { id: 2, name: '上海' },
    { id: 3, name: '重庆' },
    { id: 4, name: '成都' },
    { id: 5, name: '武汉' },
    { id: 6, name: '大连' },
  ],
  cities: [
    {
      id: 0,
      cityName: '北京',
      banner: 'https://static.web.sdo.com/jijiamobile/pic/ff14/wallpaper/20200204/ffxiv_5.1patch_01_2560x1440.jpg',
      videoList: Array.of.apply(null, new Array(5)).map(() => ({
        id: 123,
        title: '最终幻想14 - 5.2版本「追忆的凶星」',
        poster:
          'https://static.web.sdo.com/jijiamobile/pic/ff14/wallpaper/20200721patch52/ffxiv_5.2patch_01_1438x2592.jpg',
      })),
      cardList: Array.of
        .apply(null, new Array(5))
        .map(
          () => 'https://static.web.sdo.com/jijiamobile/pic/ff14/wallpaper/20190528/ffxiv_4.5patch_01_2560x1440.jpg',
        ),
      carnival: {
        guests: [],
        position: '漫展场地.jpg',
        timeLine: {
          '8月15日': [
            {
              title: '嘉宾板块',
              list: [
                {
                  title: 'Coser枣糕',
                  desc: ['10:30-11:30 签售会', '11:30-12:00 见面会', '13:30-15:00 合影会'],
                },
                {
                  title: '诺言Jason',
                  desc: ['10:30-12:30 签售会', '14:00-14:30 见面会'],
                },
              ],
            },
            {
              title: '主舞台流程',
              list: [
                {
                  title: '',
                  desc: [
                    '9:30-10:30 国产动画展映（主舞台）',
                    '10:30-11:30 舞台剧表演',
                    '11:30-12:00 枣糕见面会',
                    '13:00-13:20 Lolita Fashion Show',
                    '13:20-13:30 幻梦大抽奖',
                    '13:30-14:00 国风计划上半场',
                    '14:00-14:30 诺言见面会',
                    '14:30-16:00 国风计划下半场',
                  ],
                },
              ],
            },
            {
              title: '芬达互动舞台板块',
              list: [
                {
                  title: '',
                  desc: ['10:00-12:00 健康宅计划', '13:00-14:00 随机宅舞', '14:00-16:00 吃鸡大赛寻找“青岛鸡王”'],
                },
              ],
            },
          ],
          '8月16日': [
            {
              title: '嘉宾板块',
              list: [
                {
                  title: 'CV糖醋排骨',
                  desc: ['10:30-12:30 签售会', '13:20-14:00 见面'],
                },
                {
                  title: 'Coser 夙胤言生',
                  desc: ['13:00 签售会开始'],
                },
              ],
            },
            {
              title: '主舞台流程',
              list: [
                {
                  title: '',
                  desc: [
                    '9:30-10:30 国产动画展映',
                    '10:30-12:00 随机宅舞+互动游戏',
                    '13:20-14:00 糖醋排骨见面会',
                    '14:00-16:00  DC Live 等你最后的燃',
                  ],
                },
              ],
            },
            {
              title: '芬达互动舞台板块',
              list: [
                {
                  title: '',
                  desc: ['10:00-12:00 自由舞台', '13:00-14:30 漫展CP一线牵', '14:30-16:30 全民尬舞'],
                },
              ],
            },
          ],
        },
        address: {
          title: '北京漫展',
          location: '北京漫展在xxx这个地方',
          img: 'xxx.jpg',
          subway: '快速直达专线82路→地铁4号线大兴线快速直达专线82路→地铁4号线大兴线',
          bus: '快速直达专线82路→地铁4号线大兴线快速直达专线82路→地铁4号线大兴线',
        },
      },
      concert: {},
    },
  ],
}

export const MOCK_QA = [
  {
    title: '爱奇艺动漫游戏嘉年华与其他的二次元活动相比，有什么与众不同之处？',
    desc:
      '爱奇艺动漫游戏嘉年华希望打造一个能和二次元小伙伴们分享、互动的社区乐园，让ACGN不仅好玩有趣，还要让正能量up up，做你的温暖充电宝！<br /> 在活动版块里，我们会打造城市漫展、IP主题展、动漫音乐会、Jump！Jump！舞蹈大赛，让多才多艺的你能够进行多维度和多形式的展示、交流、探索。爱奇艺想和你一起冲破线上线下的隔阂，连接起分散在各地的同好，打造积极向上的二次元文化氛围，共同创造属于二次元的桃花源！',
  },
  {
    title: '爱奇艺动漫游戏嘉年华和原先的城市漫展（如CC&CC国际动漫嘉年华）之间是什么关系？',
    desc:
      '叮咚！爱奇艺是各个城市漫展的坚实伙伴，会将更多优质内容带到当地漫展，施加强大的魔法来给小伙伴们带来更好的体验，让你不再因漫展的区域间隔而苦恼，让更多和你一样的同好参与进来。在这里，遇见不同地方、不尽相同但一样精彩的ACGN文化！',
  },
  {
    title: '城市漫展和IP主题展有什么不同？',
    desc:
      '爱奇艺动漫游戏嘉年华的城市漫展是大型综合类的漫展，主打多方位、沉浸式、重体验的调性。IP主题展一般出没于城市地标建筑、商圈或高校，更“小巧灵活”，需要满满的欧气和一双善于发现的眼睛喔！而且IP主题展覆盖的年龄更加广泛，让你逛街休闲的时候也能随时进入“异世界”，发现更多乐趣，碰撞出不一样的火花。',
  },
  {
    title: '什么是动漫音乐会？',
    desc:
      '动漫音乐会隶属于爱奇艺动漫游戏嘉年华，是爱奇艺打造的以二次元内容为主的专业音乐演出活动。爱奇艺的百宝箱里有各种惊喜，在这里，解锁爱奇艺自制精品IP的音乐作品、漫改剧作品，还有知名唱见倾情演唱，爱奇艺自有IP的三次元明星破圈碰撞。视听盛宴，巅峰盛会，尽在动漫音乐会！',
  },
  {
    title: '线下活动以后会考虑往其他城市拓展吗？',
    desc:
      '当然啦，异次元空间怎么会被地域绊住脚步呢！请大家多多关注、多多参与、多多支持，爱奇艺动漫游戏嘉年华将带大家解锁更多地区，说不定下一站就在你的城市！',
  },
  {
    title: '在哪里能及时获取爱奇艺动漫游戏嘉年华的最新信息呢？',
    desc:
      '请小伙伴关注爱奇艺动漫游戏嘉年华主题页面的动态，或者下载叭嗒APP，两种方式都可以第一时间帮助大家抓住最新消息喔。悄悄告诉你个小秘密，我们会时不时发起抽奖或互动，一般人我不告诉ta~（叉会儿腰）',
  },
  {
    title: '页面中提到的叭嗒社区是什么？',
    desc:
      '叭嗒是由爱奇艺推出的泛次元互动娱乐社区APP，一站提供动漫内容+社区互动玩法。在叭嗒，你不仅能一站追更经典日漫、国漫新番、人气漫画，还能跟同好畅聊兴趣爱好，COS、绘画、情感扩列……好看好玩，尽在叭嗒，还不快来一起玩耍！',
  },
  {
    title: '页面中“云相册”板块是什么？',
    desc:
      '锵锵~！这里是爱奇艺动漫游戏嘉年华的魔法相册，收纳着往期所有已举办的城市漫展的照片。打开相册，即可回溯时光，再现当时的欢乐瞬间。',
  },
  {
    title: '新手村指导：畅游爱奇艺动漫游戏嘉年华线下活动需要做好哪些准备呢？',
    desc: [
      {
        title: '防疫须知',
        desc:
          '为了个人卫生安全考虑，请各位在室内佩戴口罩，戴口罩可以更好的防范病菌传播，请不要觉得是一件极其费力的事情，如戴口罩发现呼吸略有不通畅，请立即到门口附近或室外呼吸新鲜空气，共同防疫人人有责，感谢您的配合。<br />场内厕所配备消毒洗手液；场内会展中心工作人员也会做好消毒措施；门口红外线测温后入场。',
      },
      {
        title: '禁止危险行为',
        desc:
          '每次入场请配合入场安检。会场内全面禁止明火、禁止金属刀具、禁止易燃易爆或有毒危险品进入。全天禁止吸烟、禁止快速奔跑追逐、禁止推倒等危险行为。严禁携带包含水弹、软弹、BB弹的任何弹药入场。',
      },
      {
        title: '注意财产保护',
        desc: '会场内请务必保管好自己的随身财物，谨防丢失。手机、钱包、相机等贵重物品请务必随身携带。',
      },
      {
        title: '健康与应急',
        desc:
          '如在场内忽然感到身体不适，或发现他人有不良状况的，请尽快告知附近身穿黄马甲的工作人员。<br />请注意防暑，尽量不要挑战大自然，没必要成为反季节小战士，即便是和小伙伴约饭也要注意饮食控制，请元气十足地在漫展玩个痛快吧！',
      },
    ],
  },
]

export const MOCK_COOPERATE = [
  {
    name: '春秋封神',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/cqfs.jpg',
  },
  {
    name: '云中居三子',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/yzjsz.jpg',
  },
  {
    name: '招柴',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/zc.jpg',
  },
  {
    name: '郡主稳住，人设不能崩',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/jzwz.jpg',
  },
  {
    name: '风起洛阳之腐草为萤',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/fqly.jpg',
  },
  {
    name: '本剑仙绝不为奴',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/bjxjbwn.jpg',
  },
  {
    name: '苍兰决',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/clj.jpg',
  },
  {
    name: '虚凰问天',
    img: 'https://static-acn.iqiyi.com/activity/IFC2021/cooperate/xhwt.jpg',
  },
]

export const IMG_LIST = {
  GUESTS_DEFAULT_IMG: require('@/assets/carnival2020/pic_default_1_1.jpg'),
  NO_DATA_IMG: require('@/assets/carnival2020/no_data.jpg'),
}
